<template>
  <div class="page-wrapper empGroup-wrapper">
    <div class="container-fluid" ref="employerContainer">
      <breadcrumb :items="breadcrumbItems" />
      <div class="page-title emp-grp-title">
        <div class="grp-title">
        <h1>
          Employers & Groups
          </h1>
          <div class="addnew__dropdown">
            <b-dropdown text="Add New" ref="addNewDropdown">
              <div>
                <b-form-group class="addnew__form">
                  <template v-slot="{ ariaDescribedby }">
                    <div class="domain-checkboxes">
                      <b-form-checkbox
                        v-for="domain in domains"
                        :key="domain.id"
                        v-model="selected"
                        :value="domain.id"
                        :aria-describedby="ariaDescribedby"
                        :aria-label="domain.domain"
                        :id="'checkbox-' + domain.id"
                        class="domain-checkbox"
                      >
                        {{ domain.name }}
                      </b-form-checkbox>
                    </div>
                  </template>
                </b-form-group>
              </div>
              <div class="button_registration">
                <button
                  :disabled="!this.selected.length > 0"
                  :class="{ disabled_button: !this.selected.length > 0 }"
                  class="addnew_submit_button"
                  @click.prevent="groupRegistrationLink"
                >
                  Begin Registration
                </button>
              </div>
            </b-dropdown>
          </div>
          <a
            href="javascript:void(0)"
            @click.prevent="
              openRegistrationLinkModel('sendEmailRegistrationLinkEmployer')
            "
            style="background: #3bb54a !important"
            class="registration-link btn reg-link-btn"
          >
            Send Registration Link
          </a>
          <a
              href="/view-reg-log/group"
              style="background: #cb8531 !important"
              class="reg-link-log-btn btn reg-link-btn"
            >
              View Registration Link Logs
            </a>
            <a
              href="/pending/submission"
              style="background: #15ccc3 !important"
              class="reg-link-log-btn btn reg-link-btn"
            >
              View Pending Group Submissions
            </a> 
      </div>
        <button class="clear-search" @click="clearData">Clear Search</button>
      </div>

      <div class="">
        <employer-group-list-search
          :filters.sync="filterQuery"
          :active-quick-filter="activeQuickFilter"
          @onSearch="searchData"
          @switchLogs="openLogModal"
          @quick-filter="setQuickDateFilter"
        />
      </div>
      <div class="employerTable-card">
        <div class="top-pagination">
          <pagination :rows.sync="rows" :filters="filterQuery" />
        </div>
        <employer-group-list-table
          :allDomains="this.domains"
          :rows.sync="rows"
          :is-initial-load="isFirstLoad"
          :active-quick-filter="activeQuickFilter"
          @refreshList="getAll(filterQuery)"
          @quick-filter="setQuickDateFilter"
          ref="employerSwitchDataRef"
        />
        <send-registration-link-email-employer-modal />
        <pagination :rows.sync="rows" :filters="filterQuery" />
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import { mapGetters } from "vuex";
import Helper from "@/resource/Helper";
import EmployerGroupListTable from "./partials/EmployerGroupListTable.vue";
import EmployerGroupListSearch from "./partials/EmployerGroupListSearch.vue";
import SendRegistrationLinkEmailEmployerModal from "./modals/SendRegistrationLinkEmailEmployerModal";

export default {
  components: {
    EmployerGroupListTable,
    EmployerGroupListSearch,
    SendRegistrationLinkEmailEmployerModal,
  },
  name: "EmployerGroupList",
  data: () => ({
    rows: [],
    filterQuery: {
      group_code: "",
      group_name: "",
      group_email: "",
      agent_id: "",
      state: "",
      status: "",
      effective_date: "",
      signup_date_from: "",
      signup_date_to: "",
      industry: "",
      type: "",
      group_type: "",
      routing_number: "",
      bank_account_last4: "",
      account_name: "",
    },
    domains: [],
    selected: [],
    allSelected: false,
    activeQuickFilter: null,
    isFirstLoad: true,
  }),
  computed: {
    ...mapGetters({ rep: "rep" }),
  },
  methods: {
    toggleAll() {
      if (this.allSelected) {
        this.selected = this.domains.map((domain) => domain.id);
      } else {
        this.selected = [];
      }
    },
    groupRegistrationLink() {
      let selectedDomainIds = this.selected.join(",");
      let encodedDomainIds = btoa(selectedDomainIds);
      const groupRegistrationLink =
        this.$endpoint.GROUP_APP_URL +
        `/registration?repCode=${this.rep.code}&domainIds=${encodedDomainIds}`;
      window.open(groupRegistrationLink, "_blank");
      this.closeDropdown();
    },
    openRegistrationLinkModel(modelId) {
      this.$bvModal.show(modelId);
    },
    getDomain() {
      Api.get("v2/get-enrollment-site", {
        headers: {
          Authorization: process.env.VUE_APP_REG_API_KEY,
        },
      }).then((response) => {
        this.domains = response.data.data;
      });
    },
    closeDropdown() {
      this.$refs.addNewDropdown.hide(); // Method to close dropdown
    },
    clearData() {
      this.filterQuery = {
        group_code: "",
        group_name: "",
        agent_id: "",
        state: "",
        status: "",
        effective_date: "",
        signup_date_from: "",
        signup_date_to: "",
        industry: "",
        group_type: "",
        routing_number: "",
        bank_account_last4: "",
        account_name: "",
      };
      this.activeQuickFilter = null;
      this.getAll();
    },
    searchData(filters) {
      this.filterQuery = filters;
      this.getAll(this.filterQuery);
    },
    setQuickDateFilter(range) {
      const fmt = (d) => d.toISOString().split("T")[0];
      const now = new Date();

      // Toggle off if same button clicked again
      if (this.activeQuickFilter === range) {
        this.activeQuickFilter = null;
        this.filterQuery.signup_date_from = "";
        this.filterQuery.signup_date_to = "";
        this.getAll(this.filterQuery);
        return;
      }

      this.activeQuickFilter = range;

      if (range === "all") {
        this.filterQuery.signup_date_from = "";
        this.filterQuery.signup_date_to = "";
        this.getAll(this.filterQuery);
        return;
      } else if (range === "today") {
        const t = fmt(now);
        this.filterQuery.signup_date_from = t;
        this.filterQuery.signup_date_to = t;
      } else if (range === "week") {
        const day = now.getDay();
        const monday = new Date(now);
        monday.setDate(now.getDate() - ((day + 6) % 7));
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        this.filterQuery.signup_date_from = fmt(monday);
        this.filterQuery.signup_date_to = fmt(sunday);
      } else if (range === "month") {
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.filterQuery.signup_date_from = fmt(first);
        this.filterQuery.signup_date_to = fmt(last);
      }

      this.getAll(this.filterQuery);
    },
    getAll(filters = []) {
      let url;
      let loader = this.$loading.show();

      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-all-employer-and-group?${filterUrl}`;
      } else {
        url = `v2/get-all-employer-and-group`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
          this.isFirstLoad = false;
        })
        .catch(() => {
          this.rows = [];
          this.isFirstLoad = false;
          console.log("error");
        })
        .finally(() => {
          loader.hide();
        });
    },
    openLogModal() {
      console.log('ref>>', this.$refs.employerSwitchDataRef);
      this.$refs.employerSwitchDataRef.openLogModal();
    },
  },

  created() {
    this.getDomain();
  },
};
</script>
<style src="@/assets/css/employer-groups.css"></style>

<style>
.addnew__dropdown {
  display: inline-block;
}
.addnew__dropdown ul {
  z-index: 1;
  min-width: 200px;
}
.addnew__dropdown .btn-secondary {
  background: #03c3ec !important;
  font-size: 14px;
  color: #fff;
  border-radius: 4px;
  padding: 6px 12px;
  font-weight: 600;
  border: none;
}
.button_registration .disabled_button {
  background: rgb(176, 176, 176) !important;
  opacity: 999;
  border-radius: 4px;
  color: #737070;
  padding: 0.5rem 1rem;
  font-size: 14px;
  border: none;
}
.button_registration {
  margin-bottom: 0.5rem;
}
.addnew__form {
  padding: 10px;
  font-weight: 500;
}
.custom-control-input {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.domain-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  padding: 10px;
  border-bottom: 0.2px solid rgba(0, 0, 0, 0.1);
}
.addnew_submit_button {
  background-color: #03c3ec;
  text-align: center;
  font-size: 18px;
  border-radius: 4px;
  color: #fff;
  padding: 0.5rem 1rem;
  /* min-width: 100%; */
  border: none;
  display: block;
  margin: auto;
  font-size: 14px;
}
.domain-checkboxes .custom-control-label::before {
  border: none;
  background: transparent;
}

.emp-grp-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* allows wrapping for small screens */
  gap: 10px;
  margin-bottom: 1rem;
}

.grp-title{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.reg-link-btn {
  font-size: 12px;
  color: #fff;
  border-radius: 4px;
  padding: 0.45rem 0.8rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: fit-content;
  text-align: center;
  white-space: nowrap;
}

.reg-link-btn:hover{
  color: #fff;
}
@media (max-width:645px) {
  .emp-grp-title{
    display: flex;
}
.grp-title h1{
  margin-bottom: 0.5rem !important;
}
.addnew__dropdown .btn-secondary{
  margin-left: 0;
  margin-top: 0;
}
.reg-link-btn{
  padding: 0.55rem ;
}
.emp-grp-title{
  align-items: end;
}
}
@media (max-width:346px) {
  .reg-link-btn{
    display: block;
    margin-left: 0;
    margin-top: 0.5rem  ;
    width: max-content;
  }
}
  
@media (max-width: 992px) {
  .emp-grp-title {
    flex-direction: column;
    align-items: flex-start;
  }

  .grp-title {
    flex-wrap: wrap;
    gap: 10px;
  }

  .reg-link-btn,
  .addnew__dropdown .btn-secondary {
    font-size: 13px;
  }
}

@media (max-width: 576px) {
  .emp-grp-title {
    flex-direction: column;
    align-items: stretch;
  }

  .grp-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .grp-title h1 {
    margin-bottom: 0.4rem;
  }

  .addnew__dropdown,
  .btn-group,
  .addnew__dropdown .btn-secondary {
    width: 100%;
  }

  .reg-link-btn {
    width: 100%;
    text-align: center;
    margin-left: 0;
  }

  .clear-search {
    width: 100%;
    margin-top: 0.5rem;
  }
}

@media (max-width: 375px) {
  .grp-title h1 {
    font-size: 16px;
  }

  .addnew__dropdown .btn-secondary {
    font-size: 12px;
    padding: 0.4rem 0.6rem;
  }
}
</style>
